module.exports = __webpack_public_path__ + "media/bootstrap-icons/egg-d7a722eb.svg";